<template>
    <div>
        <div v-if="key">
            <div class="container">
                <div class="row">
                    <div class="col">
                      <h3>{{ $t('sell.headline') }}</h3>

                        <form v-on:submit.prevent="findPreparedCode">
                            <div class="container">
                                <div class="row">
                                    <div class="col-8">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <label for="check-code" class="col-sm-5 col-form-label">{{$t('voucher.code')}}</label>
                                                <div class="col">
                                                    <input type="text" class="form-control" id="check-code" required v-model="preparedCode">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <button type="submit" class="btn btn-primary">
                                            <font-awesome-icon icon="search"/>
                                            {{$t('voucher.search')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <p><em>{{$t('sell.help.description')}}</em></p>

                        <h6>{{$t('sell.help.steps.headline')}}</h6>
                        <ol>
                          <li>{{ $t('sell.help.steps.step1') }}</li>
                          <li>{{ $t('sell.help.steps.step2') }}</li>
                          <li>{{ $t('sell.help.steps.step3') }}</li>
                          <li>{{ $t('sell.help.steps.step4') }}</li>
                        </ol>

                        <br>
                        <br>
                        <br>
                        <div v-if="lastVoucher">
                            <h4>{{ $t('sell.last.headline') }}</h4>
                            <div><strong>{{$t('voucher.code')}}:</strong> ******{{lastVoucher.code.substr(6)}}</div>
                            <div><strong>{{$t('voucher.value')}}:</strong> {{lastVoucher.price_value}} {{$t('currency')}}</div>
                            <div><strong>{{$t('voucher.validTo')}}:</strong> {{lastVoucher.valid_to.substr(8,2)}}. {{lastVoucher.valid_to.substr(5,2)}}. {{lastVoucher.valid_to.substr(0,4)}}</div>
                        </div>
                    </div>


                    <div class="col">

                        <h3>{{$t('apply.headline')}}</h3>

                        <form v-on:submit.prevent="findLockedCode">
                            <div class="container">
                                <div class="row">
                                    <div class="col-8">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <label for="check-voucher" class="col-sm-5 col-form-label">{{ $t('voucher.code') }}</label>
                                                <div class="col-sm">
                                                    <input type="text" class="form-control" id="check-voucher" required v-model="lockedCode">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <button type="submit" class="btn btn-primary">
                                            <font-awesome-icon icon="search"/>
                                            {{ $t('voucher.search') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <p><em>{{$t('apply.help.description')}}</em></p>

                        <h6>{{$t('apply.help.steps.headline')}}</h6>
                        <ol>
                            <li>{{ $t('apply.help.steps.step1') }}</li>
                            <li>{{ $t('apply.help.steps.step2') }}</li>
                            <li>{{ $t('apply.help.steps.step3') }}</li>
                        </ol>

                        <br>
                        <br>

                        <h3>{{ $t('processing.headline') }}</h3>

                        <div v-if="locked === null" class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
                        </div>

                        <div v-else-if="typeof locked === 'string'">
                            <div class="alert alert-danger">{{locked}}</div>
                        </div>

                        <p v-else-if="locked.length === 0" class="alert alert-info">
                            {{ $t('processing.empty') }}
                        </p>

                        <table v-else class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th>{{ $t('voucher.code') }}</th>
                                <th>{{ $t('voucher.value') }}</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="lock in locked" v-bind:key="lock.id">
                                <td>{{lock.voucher.code}}</td>
                                <td class="text-right">{{lock.voucher.price_value}} {{ $t('currency') }}</td>
                                <td>
                                    <a href="" class="btn btn-sm btn-success" v-on:click.prevent="applyCode(lock.voucher)">
                                        <font-awesome-icon icon="check"/>
                                        {{ $t('processing.button.yes') }}
                                    </a>
                                    &nbsp;
                                    <a href="" class="btn btn-sm btn-danger" v-on:click.prevent="deleteLock(lock.voucher.code)">
                                        <font-awesome-icon icon="times"/>
                                        {{ $t('processing.button.no') }}
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>


                        <div class="text-right">
                            <a href="#" v-on:click="reloadLocks">
                                <font-awesome-icon icon="download"/>
                                {{ $t('refresh') }}
                            </a>
                        </div>

                    </div>

                </div>
            </div>

            <b-modal id="modal-prepared-code" centered :title="$t('sell.title')" @shown="focusInput">
                <div v-if="preparedVoucher === 'loading'" class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
                </div>
                <div v-else-if="preparedVoucher === 'success'">
                    <b-alert show variant="success">{{ $t('message.success.voucherActivated') }}</b-alert>
                    <div v-if="lastVoucher">
                        <div><strong>{{ $t('voucher.code') }}:</strong> {{lastVoucher.code}}</div>
                        <div><strong>{{ $t('voucher.value') }}:</strong> {{lastVoucher.price_value}} {{$t('currency')}}</div>
                        <div style="color:red"><strong>{{ $t('voucher.validTo') }}:</strong> {{lastVoucher.valid_to.substr(8,2)}}. {{lastVoucher.valid_to.substr(5,2)}}. {{lastVoucher.valid_to.substr(0,4)}}</div>
                    </div>
                </div>
                <div v-else-if="typeof preparedVoucher === 'string'">
                    <b-alert show variant="danger">{{preparedVoucher}}</b-alert>
                </div>
                <div v-else-if="preparedVoucher">
                    <b-alert show variant="warning" v-if="preparedVoucher.active">
                        {{ $t('message.voucherDuplicated', {code: preparedVoucher.code, validFrom: preparedVoucher.validFrom}) }}
                    </b-alert>
                    <label>{{ $t('voucher.code') }}:</label>
                    <b-form-input disabled :value="preparedVoucher.code"></b-form-input>
                    <div v-if="!preparedVoucher.active">
                        <br>
                        <label for="prepared-receipt">{{ $t('voucher.receiptNumber') }}:</label>
                        <b-form-input id="prepared-receipt" ref="input" v-model="preparedReceipt" trim required></b-form-input>
                    </div>
                </div>
                <template slot="modal-footer" slot-scope="{ ok, cancel }">
                    <div v-if="preparedVoucher.code && !preparedVoucher.active">
                        <b-button size="lg" variant="success" v-on:click="activateVoucher" :disabled="!preparedReceipt">{{ $t('sell.button') }}</b-button>
                        &nbsp;
                        <b-button size="sm" variant="outline-secondary" @click="cancel()">{{ $t('close') }}</b-button>
                    </div>
                    <div v-else>
                    </div>
                </template>
            </b-modal>

            <b-modal id="modal-locked-code" centered :title="$t('apply.title.step1')">

                <div v-if="lockedVoucher === 'loading'" class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%"></div>
                </div>
                <div v-else-if="lockedVoucher === 'success'">
                    <b-alert show variant="success">{{ $t('message.success.voucherPrepared') }}</b-alert>
                </div>
                <div v-else-if="typeof lockedVoucher === 'string'">
                    <b-alert show variant="danger">{{lockedVoucher}}</b-alert>
                </div>
                <div v-else-if="lockedVoucher">
                    <b-alert show variant="danger" v-if="!lockedVoucher.valid">{{ $t('message.voucherInvalid') }}</b-alert>
                    <label>{{ $t('voucher.code') }}:</label>
                    <b-form-input disabled :value="lockedVoucher.code"></b-form-input>
                </div>
                <template slot="modal-footer" slot-scope="{ ok, cancel }">
                    <div v-if="lockedVoucher.code && lockedVoucher.valid">
                        <b-button size="lg" variant="success" v-on:click="lockVoucher">{{ $t('apply.prepareButton') }}</b-button>
                        &nbsp;
                        <b-button size="sm" variant="outline-secondary" @click="cancel()">{{ $t('close') }}</b-button>
                    </div>
                    <div v-else></div>
                </template>
            </b-modal>

        </div>
        <div v-else>
            <b-alert show variant="danger">{{ $t('message.invalidKey') }}</b-alert>
        </div>
    </div>
</template>

<script>
    const api = require('axios');
    const baseUri = `https://${window.location.host}/api/`;
    export default {
        data: () => {
            return {
                locked: null,
                preparedCode: '',
                preparedVoucher: 'loading',
                lockedCode: '',
                lockedVoucher: 'loading',
                key: null,
                lastVoucher: null,
                preparedReceipt: null
            }
        },
        name: 'Index',
        mounted: function () {
            const urlParams = new URLSearchParams(window.location.search);
            this.key = urlParams.get('key');
            if (this.key) {
                this.reloadLocks();
            }
        },
        methods: {
            applyCode(voucher) {
                this.$bvModal.msgBoxConfirm(this.$t('apply.dialog.message', {code: voucher.code, value: voucher.price_value}), {
                    title: this.$t('apply.dialog.title'),
                    okVariant: 'success',
                    okTitle: this.$t('apply.dialog.button'),
                    cancelTitle: this.$t('back'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value) {
                            this.locked = null;
                            api.get(baseUri + 'apply', {params: {code: voucher.code, key: this.key}})
                                .then(() => {
                                    this.$bvModal.msgBoxOk(this.$t('message.success.voucherApplied'))
                                })
                                .catch((error) => {
                                    this.$bvModal.msgBoxOk(this.$t('message.voucherApplyError'), {title: this.errorMessageFromResponse(error), okVariant: 'danger',});
                                })
                                .finally(this.reloadLocks)
                        }
                    })
            },
            deleteLock(code) {
                this.locked = null;
                api.get(baseUri + 'release-lock', {params: {code: code, key: this.key}})
                    .finally(this.reloadLocks);
            },
            focusInput: () => {
                // this.$refs.input.focus() @todo
            },
            activateVoucher() {
                this.preparedVoucher = 'loading';
                api.get(baseUri + 'activate', {params: {code: this.preparedCode, key: this.key, note: this.preparedReceipt}})
                    .then((response) => {
                        this.preparedVoucher = 'success';
                        this.preparedCode = null;
                        this.preparedReceipt = null;
                        this.lastVoucher = response.data;
                    })
                    .catch(error => {
                        this.preparedReceipt = null;
                        this.preparedVoucher = this.errorMessageFromResponse(error)
                    });
            },
            lockVoucher() {
                this.lockedVoucher = 'loading';
                api.get(baseUri + 'lock', {params: {code: this.lockedCode, key: this.key}})
                    .then(() => {
                        this.lockedVoucher = 'success';
                        this.lockedCode = null;
                        this.reloadLocks();
                    })
                    .catch(error => {
                      this.lockedVoucher = this.errorMessageFromResponse(error)
                    });
            },
            findLockedCode() {
                if (this.lockedCode.length === 0) {
                    return;
                }
                this.lockedVoucher = 'loading';
                this.$bvModal.show('modal-locked-code');

                api.get(baseUri + 'find', {params: {code: this.lockedCode}})
                    .then(response => {
                        this.lockedVoucher = response.data;
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 404) {
                            this.lockedVoucher = this.$t('message.voucherNotFound', {code: this.lockedCode});
                        } else {
                            this.lockedVoucher = this.errorMessageFromResponse(error)
                        }
                    });

            },
            findPreparedCode() {
                if (this.preparedCode.length === 0) {
                    return;
                }
                this.preparedVoucher = 'loading';
                this.$bvModal.show('modal-prepared-code');

                api.get(baseUri + 'find', {params: {code: this.preparedCode}})
                    .then(response => {
                        this.preparedVoucher = response.data;
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 404) {
                            this.preparedVoucher = this.$t('message.voucherNotFound', {code: this.preparedCode});
                        } else {
                           this.preparedVoucher = this.errorMessageFromResponse(error)
                        }
                    });

            },
            reloadLocks() {
                this.locked = null;
                api.get(baseUri + 'locks', {
                    params: {
                        key: this.key
                    }
                })
                    .then(response => {
                        this.locked = response.data;
                    })
                    .catch(error => {
                      this.locked = this.errorMessageFromResponse(error)
                    });
            },
            errorMessageFromResponse(error) {
              if (error.response && error.response.status === 403) {
                return this.$t('message.accessDenied')
              }
              let message = error.message
              if (error.response && error.response.data) {
                const rawData = JSON.stringify(error.response.data)
                if (rawData.indexOf('code is locked') > -1) {
                  message = this.$t('message.voucherLocked')
                } else {
                  message += "\n" + JSON.stringify(error.response.data)
                }
              }
              this.$t('message.error', {err: message})
              return message
            }
        }
    }
</script>

<style scoped>
    li{
        margin-bottom: 5px;
    }
</style>
